// @ts-check

/** @param {string} name  */
function getNumber(name) {
  const [, match] = name?.match(/Tisch ([\w--,\s]+)/) || [];
  return (match || name || '').trim();
}

/** @param {string} name  */
function getNumbers(name) {
  const numbers = getNumber(name);
  {
    // Case 1: "120-122"
    const [from$, to$] = numbers?.split(/\s*-\s*/);
    if (from$ && to$) {
      const from = Number(from$);
      const to = Number(to$);
      if (from && to && from <= to) {
        return [...Array(to - from + 1)].map((_, index) =>
          String(from + index)
        );
      }
    }
  }
  {
    // Case 2: "120,122" or "120"
    // Taken from austria.enhanceExhibitor.js
    // Multiple stands may be separated by commas and optional spaces ("1, 2,3, 4" or "1,2 (Zeremoniensaal)")
    const [, stands] = numbers.trim().match(/([^(]*)/) || [];
    return (stands || numbers)
      .trim()
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }
}

/** @param {string | undefined} standName  */
function getRoomName(standName) {
  const [, match] = standName?.match(/\((.*)\)/) || [];
  return match;
}
/** @param {string | undefined} standName  */
function getStandTypeName(standName) {
  const [, match] = standName?.match(/^(\w+)/) || [];
  return match;
}

module.exports = {
  getNumber,
  getNumbers,
  getRoomName,
  getStandTypeName,
};
